import React from 'react';
import { Link } from 'react-router-dom';

const PublicHeader = ({ title, subtitle, showBackToHome = true }) => {
    return (
        <>
            {/* Header Banner */}
            <header className="backdrop-blur-lg sticky top-0 z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between items-center h-16">
                        {/* Logo */}
                        <Link to="/" className="flex items-center space-x-2 text-white hover:opacity-80 transition-opacity">
                            <img
                                src="/img/wh-logo-20260425.png"
                                alt="WorldsHighStreet"
                                className="h-10 w-10 rounded-full object-cover flex-shrink-0"
                            />
                            <span className="text-xl font-bold hidden sm:block">WorldsHighStreet.</span>
                        </Link>

                        {/* Right side - Login link */}
                        <div className="flex items-center space-x-4">
                            <Link
                                to="/login"
                                className="text-gray-300 hover:text-white px-3 py-2 rounded-md font-medium transition-colors"
                            >
                                Login
                            </Link>
                            <Link
                                to="/create-account"
                                className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-md font-medium transition-colors"
                            >
                                Sign Up
                            </Link>
                        </div>
                    </div>
                </div>
            </header>

            {/* Title Banner */}
            {(title || subtitle) && (
                <div className="bg-gradient-to-r from-gray-900 via-black to-gray-900 border-b border-gray-800">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
                        <div className="text-center">
                            {title && (
                                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
                                    {title}
                                </h1>
                            )}
                            {subtitle && (
                                <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto">
                                    {subtitle}
                                </p>
                            )}
                            {showBackToHome && (
                                <div className="mt-6">
                                    <Link
                                        to="/"
                                        className="inline-flex items-center text-emerald-400 hover:text-emerald-300 font-medium transition-colors"
                                    >
                                        ← Back to Home
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PublicHeader;
